import { render } from "./meddraPopup.vue?vue&type=template&id=4e980571&scoped=true"
import script from "./meddraPopup.js?vue&type=script&lang=js"
export * from "./meddraPopup.js?vue&type=script&lang=js"

import "./meddraPopup.vue?vue&type=style&index=0&id=4e980571&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e980571"]])

export default __exports__